import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  getEmployeeSalary,
  getMonthsAndYears,
  getEmployeeFiltred,
  getInfoPerEmployee,
  getSalaryPerEmployeeAndUpdateHisPrime,
  getInfoPerEmployeeWithSelection,
  generateFicheDePaie,
} from "../../../../services/RHService/PaiementService";
import { getPrimeByUser } from "../../../../services/RHService/PrimeService";
import jsPDF from "jspdf";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
import withLoader from "./../../../../components/layouts/WithLoader";
import uploadAndDownloadService from "../../../../services/uploadAndDownloadFile";

const Paiement = ({ startLoading, stopLoading }) => {
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  // Début :the card of search by month and year
  const [userSalary, setUserSalary] = useState([]);
  const [months, setMonths] = useState([]);
  const [years, setYears] = useState([]);

  const [pageLoaded, setPageLoaded] = useState(false);

  useEffect(() => {
    getMonthsAndYears(getCurrentUserId())
      .then((resp) => {
        setMonths(resp.data.success.months);
        setYears(resp.data.success.years);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  const [formData, setFormData] = useState({});
  const handleInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    let value;

    if (target.type === "checkbox") {
      value = target.checked;
    } else if (target.type === "select-one") {
      value = target.value;
    } else {
      value = target.value.trim(); // Trim whitespace for non-select inputs
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleGenerateSalarySheet = async (event) => {
    event.preventDefault();

    try {
      if (
        formData.month &&
        formData.year &&
        formData.month !== "month" &&
        formData.year !== "year"
      ) {
        const response = await getEmployeeSalary(
          getCurrentUserId(),
          formData.month,
          formData.year
        );
        console.log(response);
        setUserSalary(response.success);
      } else {
        toastr.error("Veuillez choisir le mois et l'année.");
      }
    } catch (error) {
      toastr.error("Erreur get.");
    }
  };

  useEffect(() => {
    if (pageLoaded && userSalary.length !== 0) {
      const monthName = formData.month; // Function to get month name based on month value
      const year = formData.year;
      const fileName = `fiche_des_Salaires_${monthName}_${year}.xlsx`; // Include month name in the file name

      const excelDatas = userSalary.map((user) => ({
        ID: user.idUser,
        Personnels: {
          v: user.firstName + " " + user.lastName,
        },
        Rib: user.rib,
        "Numéro CNSS": user.numCnss,
        "Heure de travail": user.workHours,
        "Heure supplimentaire": user.suppHours,
        "Salaire Brut ": user.Salary,
        "Cotisation Cnss ": user.cnssContribution,
        "Cotisation Css ": user.cssContribution,
        "Salaire imposable ": user.salaryAfterDeductions,
        "Impot sur le revenue": user.taxIR,
        "Salaire Aprés Impot": user.salaryAfterTax,
        // Add other properties you want to include in the Excel file
      }));

      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(excelDatas);
      XLSX.utils.book_append_sheet(workbook, worksheet, "Feuille de salaire");
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const excelData = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      saveAs(excelData, fileName);
    }
  }, [pageLoaded, userSalary]);
  useEffect(() => {
    setPageLoaded(true);
  }, []);
  // fin :the card of search by month and year

  //recherche
  const [employees, setEmployees] = useState([]);
  const [filter, setFilter] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const filteredData1 = employees
    ? employees.filter(
        (item) =>
          (item.cin && item.cin.toLowerCase().includes(filter.toLowerCase())) ||
          (item.firstName &&
            item.firstName.toLowerCase().includes(filter.toLowerCase())) ||
          (item.lastName &&
            item.lastName.toLowerCase().includes(filter.toLowerCase()))
      )
    : [];

  useEffect(() => {
    getEmployeeFiltred(getCurrentUserId(), filter).then((data) =>
      setEmployees(data.success)
    );
  }, [filter]);

  const [selectedUsers, setSelectedUsers] = useState([]);

  //recherche
  // début pagination
  const [itemsPerPage, setItemsPerPage] = useState(5); // Nombre d'éléments par page
  const [currentPage, setCurrentPage] = useState(1); // Numéro de la page actuelle

  const nextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  // Fonction pour passer à la page précédente
  const previousPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };
  // Fonction pour changer le nombre d'éléments par page
  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1); // Réinitialiser la page actuelle à 1
  };
  // fin pagination

  ///Modal steps

  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const handleShow = (employee) => {
    setSelectedEmployee(employee);
    setShow(true);
  };
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  //handle the steps
  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 3;
  const handlePrevious = () => {
    setCurrentStep(currentStep - 1); // Met à jour la valeur de currentStep en décrémentant de 1
  };
  const handleNext = () => {
    setCurrentStep(currentStep + 1);
  };

  //step 1 : the month and year
  const [formDataInfo, setFormDataInfo] = useState({
    monthModal: "",
    yearModal: "",
    userPrimeModel: [],
  });
  const handleInputChangeInfo = (event) => {
    const target = event.target;
    const name = target.name;
    let value;

    if (target.type === "checkbox") {
      value = target.checked;
    } else if (target.type === "select-one") {
      value = target.value;
    } else {
      value = target.value.trim(); // Trim whitespace for non-select inputs
    }

    setFormDataInfo((prevFormDataInfo) => ({
      ...prevFormDataInfo,
      [name]: value,
    }));
  };
  useEffect(() => {}, [formDataInfo]);

  const isValidSelection = () => {
    return formDataInfo.monthModal !== "" && formDataInfo.yearModal !== "";
  };
  //step 2 : General info
  const [loadingForInfo, setLoadingForInfo] = useState(true);

  const [Infos, setInfos] = useState([]);

  useEffect(() => {
    fetchDataInfo().then(() => {
      setLoadingForInfo(false);
    });
  }, [selectedEmployee, formDataInfo.yearModal, formDataInfo.monthModal]);

  const fetchDataInfo = async () => {
    if (
      selectedEmployee &&
      selectedEmployee.idUser &&
      formDataInfo.yearModal &&
      formDataInfo.monthModal
    ) {
      const data = await getInfoPerEmployee(
        formDataInfo.monthModal,
        formDataInfo.yearModal,
        selectedEmployee.idUser
      );
      setInfos(data.success);
    }
  };

  //step 3 : les primes

  const [prime, setPrime] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetchData().then(() => {
      setLoading(false);
    });
  }, [selectedEmployee]);
  const fetchData = async () => {
    if (selectedEmployee && selectedEmployee.idUser) {
      const data = await getPrimeByUser(selectedEmployee.idUser);
      setPrime(data.success);
    }
  };

  //set the inputList by the default prime of user
  const [inputList, setInputList] = useState([]);

  useEffect(() => {
    if (prime.length > 0) {
      setInputList(
        prime
          .filter((c) => c.primeAmount !== null)
          .map((c) => ({ idPrime: c.idPrime, primeAmount: c.primeAmount }))
      );
    }
  }, [prime]);

  // input: is affected
  const handleCheckboxChange = (index) => {
    const updatedPrime = prime.map((c, i) =>
      i === index ? { ...c, isAffected: !c.isAffected } : c
    );
    setPrime(updatedPrime);

    // Update inputList
    const updatedInputList = updatedPrime
      .filter((c) => c.isAffected && c.primeAmount !== "")
      .map((c) => ({ idPrime: c.idPrime, primeAmount: c.primeAmount }));

    // Include additional inputs
    if (
      updatedPrime[index].idPrime === "inputCheck" &&
      updatedPrime[index].isAffected
    ) {
      updatedInputList.push({ idPrime: "inputCheck", primeAmount: "" });
    }

    setInputList(updatedInputList);
  };

  const handlePrimeAmountChange = (event, index) => {
    const { value } = event.target;
    const updatedPrime = prime.map((c, i) =>
      i === index ? { ...c, primeAmount: value || "" } : c
    );

    setPrime(updatedPrime);

    // Update inputList
    const updatedInputList = updatedPrime
      .filter((c) => c.isAffected && c.primeAmount !== "")
      .map((c) => ({ idPrime: c.idPrime, primeAmount: c.primeAmount }));

    // Include additional inputs
    const additionalInputs = updatedPrime.filter(
      (c) => c.idPrime === "inputCheck" && c.isAffected
    );
    additionalInputs.forEach((input) => {
      updatedInputList.push({ idPrime: input.idPrime, primeAmount: "" });
    });

    setInputList(updatedInputList);
  };

  //set the formData by the inputList
  useEffect(() => {
    setFormDataInfo((prevState) => ({
      ...prevState,
      userPrimeModel: inputList,
    }));
    console.log(inputList);
  }, [inputList]);

  //the steps
  const renderModalContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <Container className="d-flex justify-content-center align-items-center">
            <Row>
              <Col xs={12} md={6}>
                <label htmlFor=""> Choisir la periode</label>
              </Col>
              <Col xs={12} md={6}>
                <div className="row">
                  <div className="col-md-6 mx-3 mt-2">
                    <select
                      className="select-box form-control mt-1 "
                      id="month-select"
                      name="monthModal"
                      value={formDataInfo.monthModal}
                      onChange={handleInputChangeInfo}
                    >
                      <option className="text-center" value="">
                        --choisir le mois--
                      </option>
                      {months.map((month, index) => (
                        <option key={index} value={month}>
                          {month}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6 mx-3 mt-2">
                    <select
                      className="select-box form-control mt-1"
                      id="year-select"
                      name="yearModal"
                      value={formDataInfo.yearModal}
                      onChange={handleInputChangeInfo}
                    >
                      <option className="text-center" value="">
                        --choisir l'année--
                      </option>
                      {years.map((year, index) => (
                        <option key={index} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        );
      case 2:
        return (
          <Container>
            <Row>
              <Col xs={12} md={12}>
                <input
                  hidden
                  name="idUser"
                  value={
                    selectedEmployee && selectedEmployee.idUser
                      ? selectedEmployee.idUser
                      : ""
                  }
                  onChange={(e) =>
                    setSelectedEmployee({
                      ...selectedEmployee,
                      idUser: e.target.value,
                    })
                  }
                />
                <label>Informations générales</label>
                {loadingForInfo ? (
                  <div className="loader center"></div>
                ) : (
                  <>
                    {Infos.map((info, index) => (
                      <div key={index} className="info-container">
                        <div className="info">
                          <p>
                            {info ? (
                              <span>
                                {" "}
                                <label htmlFor="">Personnel:</label>{" "}
                                {info.firstName} {info.lastName}
                              </span>
                            ) : (
                              ""
                            )}
                          </p>
                          <p>
                            {info ? (
                              <span>
                                {" "}
                                <label htmlFor="">Nom Contrat:</label>{" "}
                                {info.nomContrat}{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </p>
                          <p>
                            {info ? (
                              <span>
                                {" "}
                                <label htmlFor="">Nom Post:</label>{" "}
                                {info.nomPost}{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </p>
                          <p>
                            {info ? (
                              <span>
                                {" "}
                                <label htmlFor="">Heures travaillé:</label>{" "}
                                {info.workHours} / {info.nbHrsMois} heures{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </p>
                          <p>
                            {info ? (
                              <span>
                                {" "}
                                <label htmlFor="">
                                  Heures supplimentaire:
                                </label>{" "}
                                {info.suppHours} heures{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </p>
                          <p>
                            {info ? (
                              <span>
                                {" "}
                                <label htmlFor="">Salaire de base :</label>{" "}
                                {info.salary} DT{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </p>
                          <p>
                            {info ? (
                              <span>
                                {" "}
                                <label htmlFor="">Cotisation CNSS :</label>{" "}
                                {info.cnssContribution} DT{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </p>
                          <p>
                            {info ? (
                              <span>
                                {" "}
                                <label htmlFor="">Cotisation CSS :</label>{" "}
                                {info.cssContribution} DT{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </p>
                          <p>
                            {info ? (
                              <span>
                                {" "}
                                <label htmlFor="">
                                  Salaire imposable:
                                </label>{" "}
                                {info.salary -
                                  (info.cssContribution +
                                    info.cnssContribution)}{" "}
                                DT{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </p>
                          <p>
                            {info ? (
                              <span>
                                {" "}
                                <label htmlFor="">
                                  Déduction Familiale :
                                </label>{" "}
                                {info.deductionFam} DT{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </p>
                          <p>
                            {info ? (
                              <span>
                                {" "}
                                <label htmlFor="">
                                  Impôt sur le revenu:
                                </label>{" "}
                                {info.taxIR} DT{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </p>
                          <p>
                            {info ? (
                              <span>
                                {" "}
                                <label htmlFor="">Net à payé:</label>{" "}
                                {info.salaryAfterTax} DT{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </p>
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </Col>
            </Row>
          </Container>
        );

      default:
        return (
          <Container>
            <Row>
              <Col xs={12} md={6}>
                <input
                  hidden
                  name="idUser"
                  value={
                    selectedEmployee && selectedEmployee.idUser
                      ? selectedEmployee.idUser
                      : ""
                  }
                  onChange={(e) =>
                    setSelectedEmployee({
                      ...selectedEmployee,
                      idUser: e.target.value,
                    })
                  }
                />
                {loading ? (
                  <div className="loader center"></div>
                ) : (
                  <div>
                    {prime.length !== 0 && (
                      <div>
                        {prime.map((c, index) => (
                          <div key={c.idPrime} className="row">
                            <div className="col-md-6 icheck-dark d-inline mx-1">
                              <input
                                type="checkbox"
                                id={c.nomPrime}
                                value={c.idPrime}
                                name="idPrime"
                                checked={c.isAffected}
                                onChange={() => handleCheckboxChange(index)}
                              />
                              <label htmlFor={c.nomPrime}>{c.nomPrime}</label>
                            </div>
                            <div className="col-md mx-1 mt-1">
                              <input
                                type="text"
                                className="form-control"
                                onChange={(event) =>
                                  handlePrimeAmountChange(event, index)
                                }
                                name="primeAmount"
                                value={c.primeAmount || ""}
                                placeholder="Montant de Prime"
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </Col>
            </Row>
          </Container>
        );
    }
  };
  useEffect(() => {}, [formDataInfo]);

  const [finalInfo, setFinalInfo] = useState([]);
  const onUploadFileHandler = (idFichedePaie) => {
    startLoading();
    generateFicheDePaie(getCurrentUserId(), idFichedePaie).then(
      (response) => {
        console.log("response", response);
        handleClose()

        onShowFileInOtherWizndowHandler(response.data?.path);
      }
    ).finally(()=>{
      stopLoading();
    });
  };
  const onShowFileInOtherWizndowHandler = (path) => {
    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        //Build a URL from the file
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : "+error);
      });
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    // Example: Proceed to the next step or navigate to a different page
    if (currentStep < totalSteps) {
      handleNext(); // Assuming handleNext function is defined
    } else {
      if (
        selectedEmployee &&
        selectedEmployee.idUser &&
        formDataInfo.yearModal &&
        formDataInfo.monthModal
      ) {
      
          getSalaryPerEmployeeAndUpdateHisPrime(
            selectedEmployee.idUser,
            formDataInfo.monthModal,
            formDataInfo.yearModal,
            formDataInfo.userPrimeModel
          ).then((resp)=>{
            setFinalInfo(resp.success);
            if(resp.salaryModel.urlFile===null||resp.salaryModel.urlFile==="any"){
              onUploadFileHandler(resp.salaryModel.idSalary);
              setOpenSuccessAlert(true);
              setSuccessAlertText("Enregistrement avec succée ");
            }else{
              handleClose()

              onShowFileInOtherWizndowHandler(resp.salaryModel.urlFile);
              setOpenSuccessAlert(true);
              setSuccessAlertText("Mise à jour avec succée ");
            }
          }).catch((error)=>{
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : "+error);
          })

      }
    }
  };
  // useEffect(() => {
  //   if (
  //     formDataInfo.monthModal &&
  //     formDataInfo.yearModal &&
  //     formDataInfo.monthModal !== "monthModal" &&
  //     formDataInfo.yearModal !== "yearModal"
  //   ) {
  //     generatePDF(finalInfo);
  //   }
  // }, [finalInfo]);

  // const generatePDF = (finalInfo) => {
  //   return new Promise((resolve, reject) => {
  //     const doc = new jsPDF();

  //     // Add content to the PDF
  //     doc.setFont("helvetica", "bold"); // Définir la police en gras
  //     doc.setTextColor("blue"); // Définir la couleur du texte en bleu
  //     doc.setFontSize(20); // Définir la taille de la police
  //     doc.text("BULLETIN DE PAIE", 130, 20);

  //     doc.setFontSize(12);
  //     doc.setTextColor("black");
  //     doc.text("MA SOCIETE : SOUSSE KHEZAMA", 20, 19);

  //     doc.setFontSize(12);
  //     doc.setTextColor("black");
  //     doc.text(`Numéro d'affiliation CNSS :  ${finalInfo.numCnss}`, 20, 30);

  //     doc.setTextColor("black");
  //     doc.setFontSize(12);
  //     doc.text(
  //       `MOIS : ${finalInfo.selectedMonth}  ${finalInfo.selectedYear} `,
  //       130,
  //       30
  //     );

  //     const tableData = [
  //       [
  //         `${finalInfo.idUser}`,
  //         `${finalInfo.firstName} ${finalInfo.lastName}`,
  //         `${finalInfo.nomPost}`,
  //       ],
  //     ];

  //     const tableHeaders = ["ID", "Nom et Prénom", "Qualification"];
  //     const startX = 20;
  //     const startY = 50;
  //     const rowHeight = 7;
  //     const columnWidth = 60;
  //     // Dessiner la bordure bleue
  //     doc.setDrawColor("blue");
  //     doc.setLineWidth(0.1);
  //     doc.rect(
  //       startX,
  //       startY,
  //       tableHeaders.length * columnWidth,
  //       tableData.length * rowHeight,
  //       "D"
  //     );

  //     // Dessiner l'en-tête du tableau
  //     doc.setFont("helvetica", "bold");
  //     doc.setFontSize(12);
  //     doc.setTextColor("white");
  //     doc.setFillColor("blue");
  //     doc.rect(
  //       startX,
  //       startY - rowHeight,
  //       tableHeaders.length * columnWidth,
  //       rowHeight,
  //       "F"
  //     );

  //     for (let i = 0; i < tableHeaders.length; i++) {
  //       const lineX = startX + i * columnWidth;
  //       doc.line(lineX, startY, lineX, startY + tableData.length * rowHeight);
  //       const text = tableHeaders[i];
  //       const textWidth = doc.getTextWidth(text);
  //       const textHeight =
  //         doc.internal.getLineHeight() / doc.internal.scaleFactor;
  //       const textX = startX + i * columnWidth + (columnWidth - textWidth) / 2;
  //       const textY = startY - (rowHeight - textHeight) / 2;
  //       doc.text(text, textX, textY);
  //     }

  //     // Dessiner les données du tableau
  //     doc.setFont("helvetica", "normal");
  //     doc.setFontSize(10);
  //     doc.setTextColor("black");
  //     for (let row = 0; row < tableData.length; row++) {
  //       const rowData = tableData[row];
  //       const lineY = startY + (row + 1) * rowHeight;
  //       doc.line(
  //         startX,
  //         lineY,
  //         startX + tableHeaders.length * columnWidth,
  //         lineY
  //       );
  //       for (let col = 0; col < rowData.length; col++) {
  //         const text = rowData[col];
  //         const textWidth = doc.getTextWidth(text);
  //         const textHeight =
  //           doc.internal.getLineHeight() / doc.internal.scaleFactor;
  //         const textX =
  //           startX + col * columnWidth + (columnWidth - textWidth) / 2;
  //         const textY =
  //           startY + (row + 1) * rowHeight - (rowHeight - textHeight) / 2;
  //         doc.text(text, textX, textY);
  //       }
  //     }

  //     const tableData1 = [
  //       [
  //         `${finalInfo.numCnss}`,
  //         `${finalInfo.rib}`,
  //         `${finalInfo.sf}`,
  //         `${finalInfo.nbEnf}`,
  //         `${finalInfo.nomContrat}`,
  //       ],
  //     ];
  //     const tableHeaders1 = ["Numéro CNSS", "RIB", "S.F", "ENF.", "Contrat"];
  //     const startX1 = 20;
  //     const startY1 = 65;
  //     const rowHeight1 = 7;
  //     const columnWidth1 = 30;
  //     const customWidth = 36; // Modification de la largeur de la dernière cellule
  //     doc.setDrawColor("blue");
  //     doc.setLineWidth(0.1);
  //     doc.rect(
  //       startX1,
  //       startY1,
  //       tableHeaders1.length * customWidth,
  //       tableData1.length * rowHeight1,
  //       "D"
  //     );

  //     // Dessiner l'en-tête du tableau
  //     doc.setFont("helvetica", "bold");
  //     doc.setFontSize(10);
  //     doc.setTextColor("white");
  //     doc.setFillColor("blue");
  //     doc.rect(
  //       startX1,
  //       startY1 - rowHeight1,
  //       tableHeaders1.length * customWidth,
  //       rowHeight1,
  //       "F"
  //     );

  //     for (let i = 0; i < tableHeaders1.length; i++) {
  //       const lineX1 = startX1 + i * columnWidth1;
  //       doc.line(
  //         lineX1,
  //         startY1,
  //         lineX1,
  //         startY1 + tableData1.length * rowHeight1
  //       );
  //       const text1 = tableHeaders1[i];
  //       const textWidth1 = doc.getTextWidth(text1);
  //       const textHeight1 =
  //         doc.internal.getLineHeight() / doc.internal.scaleFactor;
  //       const textX1 =
  //         startX1 + i * columnWidth1 + (columnWidth1 - textWidth1) / 2;
  //       const textY1 = startY1 - (rowHeight1 - textHeight1) / 2;
  //       doc.text(text1, textX1, textY1);
  //     }

  //     // Dessiner les données du tableau
  //     doc.setFont("helvetica", "normal");
  //     doc.setFontSize(10);
  //     doc.setTextColor("black");
  //     for (let row = 0; row < tableData1.length; row++) {
  //       const rowData1 = tableData1[row];
  //       const lineY1 = startY1 + (row + 1) * rowHeight1;
  //       doc.line(
  //         startX1,
  //         lineY1,
  //         startX1 + (tableHeaders1.length - 1) * columnWidth1 + customWidth,
  //         lineY1
  //       );
  //       for (let col = 0; col < rowData1.length; col++) {
  //         const text1 = rowData1[col];
  //         const textWidth1 = doc.getTextWidth(text1);
  //         const textHeight1 =
  //           doc.internal.getLineHeight() / doc.internal.scaleFactor;
  //         let textX1, textY1;

  //         if (col === tableHeaders1.length - 1) {
  //           const customWidthOffset = customWidth - columnWidth1 + 7;
  //           textX1 =
  //             startX1 +
  //             col * columnWidth1 +
  //             customWidthOffset +
  //             (columnWidth1 - textWidth1) / 2;
  //           textY1 =
  //             startY1 + (row + 1) * rowHeight1 - (rowHeight1 - textHeight1) / 2;
  //         } else {
  //           textX1 =
  //             startX1 + col * columnWidth1 + (columnWidth1 - textWidth1) / 2;
  //           textY1 =
  //             startY1 + (row + 1) * rowHeight1 - (rowHeight1 - textHeight1) / 2;
  //         }

  //         doc.text(text1, textX1, textY1);
  //       }
  //     }
  //     let x;
  //     let heureSupp;
  //     if (finalInfo.workHours >= finalInfo.nbHrsMois) {
  //       x = finalInfo.nbHrsMois / 8;
  //       heureSupp = finalInfo.workHours - finalInfo.nbHrsMois;
  //     } else {
  //       x = finalInfo.workHours / 8;
  //     }
  //     const tableData2 = [
  //       [`Salaire de base`, `${x}`, `${finalInfo.salary}`],
  //       [`Congé Payé`, `0`],
  //       ...(finalInfo.primeModel?.map((prime) => [
  //         `${prime.nomPrime}`,
  //         "",
  //         `${prime.primeAmount}`,
  //       ]) || []),
  //       [`Heures Supplimentaire`, `${heureSupp}`],
  //       [`Salaire brut`, "", `${finalInfo.salary}`, ""],
  //       [`Cotisation CNSS`, "", "", `${finalInfo.cnssContribution}`],
  //       [`Cotisation CSS`, "", "", `${finalInfo.cssContribution}`],
  //       [`Salaire Imposable`, ``, `${finalInfo.salaryAfterDeductions}`, ``],
  //       [`Impot sur le revenue`, ``, `${finalInfo.taxIR}`, ``],
  //       [`Net a payé`, ``, `${finalInfo.salaryAfterTax}`, ``],
  //     ];
  //     const tableHeaders2 = ["LIBELLE", "NBRE", "MONTANT", "RETENUES"];
  //     const startX2 = 20;
  //     const startY2 = 85;
  //     const rowHeight2 = 10;
  //     const columnWidth2 = 45;
  //     doc.setDrawColor("blue");
  //     doc.setLineWidth(0.1);
  //     doc.rect(
  //       startX2,
  //       startY2,
  //       tableHeaders2.length * columnWidth2,
  //       tableData2.length * rowHeight2,
  //       "D"
  //     );

  //     // Dessiner l'en-tête du tableau
  //     doc.setFont("helvetica", "bold");
  //     doc.setFontSize(10);
  //     doc.setTextColor("white");
  //     doc.setFillColor("blue");
  //     doc.rect(
  //       startX2,
  //       startY2 - rowHeight2,
  //       tableHeaders2.length * columnWidth2,
  //       rowHeight2,
  //       "F"
  //     );

  //     for (let i = 0; i < tableHeaders2.length; i++) {
  //       const lineX2 = startX2 + i * columnWidth2;
  //       doc.line(
  //         lineX2,
  //         startY2,
  //         lineX2,
  //         startY2 + tableData2.length * rowHeight2
  //       );
  //       const text2 = tableHeaders2[i];
  //       const textWidth2 = doc.getTextWidth(text2);
  //       const textHeight2 =
  //         doc.internal.getLineHeight() / doc.internal.scaleFactor;
  //       const textX2 =
  //         startX2 + i * columnWidth2 + (columnWidth2 - textWidth2) / 2;
  //       const textY2 = startY2 - (rowHeight2 - textHeight2) / 2;
  //       doc.text(text2, textX2, textY2);
  //     }

  //     // Dessiner les données du tableau
  //     doc.setFont("helvetica", "normal");
  //     doc.setFontSize(10);
  //     doc.setTextColor("black");
  //     for (let row = 0; row < tableData2.length; row++) {
  //       const rowData2 = tableData2[row];
  //       const lineY2 = startY2 + (row + 1) * rowHeight2;
  //       doc.line(
  //         startX2,
  //         lineY2,
  //         startX2 + tableHeaders2.length * columnWidth2,
  //         lineY2
  //       );
  //       for (let col = 0; col < rowData2.length; col++) {
  //         const text2 = rowData2[col];
  //         const textWidth2 = doc.getTextWidth(text2);
  //         const textHeight2 =
  //           doc.internal.getLineHeight() / doc.internal.scaleFactor;
  //         const textX2 =
  //           startX2 + col * columnWidth2 + (columnWidth2 - textWidth2) / 2;
  //         const textY2 =
  //           startY2 + (row + 1) * rowHeight2 - (rowHeight2 - textHeight2) / 2;
  //         doc.text(text2, textX2, textY2);
  //       }
  //     }
  //     const fileName = `${finalInfo.firstName}_${finalInfo.lastName}_${finalInfo.selectedMonth}_${finalInfo.selectedYear}.pdf`;

  //     // Save the PDF
  //     try {
  //       doc.save(fileName);
  //       resolve(); // Resolve the Promise when the PDF generation is complete
  //     } catch (error) {
  //       reject(error); // Reject the Promise if there's an error
  //     }
  //   });
  // };

  //Partie 3 :lorsqu'il select des user
  const handleUserSelection = (event, userId) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      setSelectedUsers((prevSelectedUsers) => [...prevSelectedUsers, userId]);
    } else {
      setSelectedUsers((prevSelectedUsers) =>
        prevSelectedUsers.filter((selectedUserId) => selectedUserId !== userId)
      );
    }
  };

  const [formDataForSelection, setFormDataForSelection] = useState({});
  const handleInputChangeForSelection = (event) => {
    const target = event.target;
    const name = target.name;
    let value;

    if (target.type === "checkbox") {
      value = target.checked;
    } else if (target.type === "select-one") {
      value = target.value;
    } else {
      value = target.value.trim();
    }

    setFormDataForSelection((prevFormDataForSelection) => ({
      ...prevFormDataForSelection,
      [name]: value,
    }));
  };
  useEffect(() => {}, [formDataForSelection]);
  useEffect(() => {}, [selectedUsers]);

  const [userSalarySelection, setUserSalarySelection] = useState([]);
  const handleGenerateSalarySheetSelection = async (event) => {
    event.preventDefault();

    try {
      if (
        selectedUsers &&
        formDataForSelection.yearSelection &&
        formDataForSelection.monthSelection
      ) {
        console.log(selectedUsers);

        const response = await getInfoPerEmployeeWithSelection(
          formDataForSelection.yearSelection,
          formDataForSelection.monthSelection,
          selectedUsers
        );
        console.log(response);
        setUserSalarySelection(response.success);
      } else {
        toastr.error("Veuillez choisir le mois et l'année.");
      }
    } catch (error) {
      toastr.error("Erreur lors de la vérification.");
    }
  };
  useEffect(() => {
    if (pageLoaded && userSalarySelection.length !== 0) {
      const monthName = formData.month; // Function to get month name based on month value
      const year = formData.year;
      const fileName = `fiche_des_Salaires_${monthName}_${year}.xlsx`; // Include month name in the file name

      const excelDatas = userSalarySelection.map((user) => ({
        ID: user.idUser,
        Personnels: {
          v: user.firstName + " " + user.lastName,
        },
        Rib: user.rib,
        "Numéro CNSS": user.numCnss,
        "Heure de travail": user.workHours,
        "Heure supplimentaire": user.suppHours,
        "Salaire Brut ": user.Salary,
        "Cotisation Cnss ": user.cnssContribution,
        "Cotisation Css ": user.cssContribution,
        "Salaire imposable ": user.salaryAfterDeductions,
        "Impot sur le revenue": user.taxIR,
        "Salaire Aprés Impot": user.salaryAfterTax,
        // Add other properties you want to include in the Excel file
      }));

      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(excelDatas);
      XLSX.utils.book_append_sheet(workbook, worksheet, "Feuille de salaire");
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const excelData = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      saveAs(excelData, fileName);
    }
  }, [userSalarySelection]);

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Visualisation de bulletin </h1>
              <hr></hr>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <i class="fa-solid fa-house"></i>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">Fiche de Paie</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Étapes pour générer la fiche de paie</Modal.Title>
        </Modal.Header>
        <Modal.Body className="show-grid">
          <Form onSubmit={handleSubmit}>{renderModalContent()}</Form>
        </Modal.Body>
        <Modal.Footer>
          {currentStep > 1 && (
            <Button variant="secondary" onClick={handlePrevious}>
              Précédent
            </Button>
          )}
          <Button
            variant="dark"
            onClick={currentStep < totalSteps ? handleNext : handleSubmit}
            disabled={!isValidSelection()}
          >
            {currentStep < totalSteps ? "Suivant" : "Terminer"}
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="container-fluid">
        <div className="row">
          <div className="col-md-6">
            <div className="card">
              <div className="card-body">
                <div className="search center mx-3 mt-3 mb-3">
                  <input
                    type="text"
                    className="searchTerm"
                    placeholder="Rechercher..."
                    value={filter}
                    onChange={(e) => {
                      setFilter(e.target.value);
                      setIsVisible(true);
                    }}
                  />
                </div>

                {isVisible && (
                  <div className="table-responsive">
                    {filteredData1.length === 0 ? (
                      <p style={{ textAlign: "center" }}>
                        Pas de résultat, veuillez vérifier !
                      </p>
                    ) : (
                      <table className="table">
                        <thead className="thead-dark">
                          <tr>
                            <th scope="col">Select</th>
                            <th scope="col">Mat.</th>
                            <th scope="col">Personnel</th>
                            <th scope="col">CIN</th>
                            <th scope="col">Fiche de paie</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredData1
                            .slice(
                              (currentPage - 1) * itemsPerPage,
                              currentPage * itemsPerPage
                            )
                            .map((employee, index) => (
                              <tr key={index}>
                                <td>
                                  <input
                                    type="checkbox"
                                    id={employee.idUser}
                                    value={employee.idUser}
                                    onChange={(e) =>
                                      handleUserSelection(e, employee.idUser)
                                    }
                                  />
                                  <label htmlFor={employee.idUser}></label>
                                </td>
                                <td>{index + 1}</td>
                                <td>
                                  {employee.firstName} {employee.lastName}
                                </td>
                                <td>{employee.cin}</td>
                                <td class="button-container">
                                  <button
                                    onClick={() => {
                                      handleShow(employee);
                                    }}
                                    type="button"
                                    class="files-style"
                                  >
                                    <i class="fa-solid fa-file file-icon"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                )}

                {isVisible ? (
                  filteredData1.length > 0 ? (
                    <>
                      <div className="pagination">
                        <button
                          className="button-paiement"
                          onClick={previousPage}
                          disabled={currentPage === 1}
                        >
                          Précédent
                        </button>
                        <span className="mx-2">{currentPage}</span>
                        <button
                          className="button-paiement"
                          onClick={nextPage}
                          disabled={
                            currentPage ===
                            Math.ceil(filteredData1.length / itemsPerPage)
                          }
                        >
                          Suivant
                        </button>
                      </div>

                      <select
                        className="select-box-card2"
                        value={itemsPerPage}
                        onChange={handleItemsPerPageChange}
                      >
                        <option className="center" value={5}>
                          5
                        </option>
                        <option className="center" value={10}>
                          10
                        </option>
                        <option className="center" value={20}>
                          20
                        </option>
                        <option className="center" value={50}>
                          50
                        </option>
                      </select>
                    </>
                  ) : null
                ) : (
                  <p style={{ textAlign: "center" }}></p>
                )}
              </div>

              {selectedUsers.length > 0 && isVisible && (
                <form onSubmit={handleGenerateSalarySheetSelection}>
                  <div className="row">
                    <select
                      className="select-box-card1 form-control mt-1 mx-4"
                      id="month-select"
                      name="monthSelection"
                      value={formDataForSelection.month}
                      onChange={handleInputChangeForSelection}
                    >
                      <option className="text-center" value="month">
                        --choisir le mois--
                      </option>
                      {months.map((month, index) => (
                        <option key={index} value={month}>
                          {month}
                        </option>
                      ))}
                    </select>
                    <select
                      className="select-box-card1 form-control mt-1"
                      id="year-select"
                      name="yearSelection"
                      value={formDataForSelection.month}
                      onChange={handleInputChangeForSelection}
                    >
                      <option className="text-center" value="year">
                        --choisir l'année--
                      </option>
                      {years.map((year, index) => (
                        <option key={index} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                    <div className="col-md text-right">
                      <button
                        className="generate right mx-2 mt-1"
                        type="submit"
                      >
                        Générer fiches de paie
                      </button>
                    </div>
                  </div>{" "}
                </form>
              )}
            </div>
          </div>

          <div className="col-md-6 ">
            <div className="card">
              <form onSubmit={handleGenerateSalarySheet}>
                <table>
                  <thead>
                    <tr>
                      <th>
                        <label htmlFor="month-select" className="mt-2 mx-2">
                          Periode de bulletin
                        </label>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <select
                          className="select-box form-control mt-1 mx-2"
                          id="month-select"
                          name="month"
                          value={formData.month}
                          onChange={handleInputChange}
                        >
                          <option className="text-center" value="month">
                            --choisir le mois--
                          </option>
                          {months.map((month, index) => (
                            <option key={index} value={month}>
                              {month}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <select
                          className="select-box form-control mt-1"
                          id="year-select"
                          name="year"
                          value={formData.year}
                          onChange={handleInputChange}
                        >
                          <option className="text-center" value="year">
                            --choisir l'année--
                          </option>
                          {years.map((year, index) => (
                            <option key={index} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>
                      </td>
                    </tr>
                    <tr className="text-right mt-2">
                      <td></td>
                      <td>
                        <button
                          className="excel-export-paiement mx-2 mt-2"
                          type="submit"
                        >
                          Générer fiches de paie
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default withLoader(Paiement);
